import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import HoldingsEditor from './HoldingsEditor/HoldingsEditor';
import {
  saveClient,
  setEditMode,
} from '../../actions/advisor';
import s from './EditHoldingsForm.css';

class EditHoldingsForm extends PureComponent {

  constructor(props) {
    super(props);
    const newClient = Object.assign({}, this.props.client);
    this.state = {
      client: newClient,
    };
    this.handleUpdateHoldings = this.handleUpdateHoldings.bind(this);
  }

  // save client with current saved state values
  saveClient = (event) => {
    const {
      client,
    } = this.state;
    event.preventDefault();
    client.expectedReturns = 0.0;
    client.expectedVolatility = 0.0;
    this.props.saveClient(client).then(() => {
      this.props.setEditMode('');
    });
  }

  clearEditMode = (event) => {
    event.preventDefault();
    this.props.setEditMode('');
  }

  handleUpdateHoldings(holdings) {
    let formattedHoldings = [{
      tickers: holdings.map(holding => {
          return holding.ticker;
      }),
      weights: holdings.map(holding => {
          return holding.weight;
      })
    }];
    const newClient = Object.assign({}, this.state.client);
    newClient.holdings = formattedHoldings;
    this.setState(Object.assign({}, this.state, {
      client: newClient,
    }));
  }

  render() {
    const {
      client,
    } = this.state;

    const params = {
      clientEmail:"advisor@test.com",
      token:"ae9f9721bbbf24d9763a1c231013e5ffd439c79103451d01eb383604cc83f7fc",
    }

    console.log(client);

    return (
      <div className={s.content}>
        <HoldingsEditor
            initialHoldings={client.holdings[client.holdings.length - 1]}
            params={params}
            //typeaheadUrl={typeaheadUrl}
            //checkTickersUrl={checkTickersUrl}
            updateHoldings={this.handleUpdateHoldings}
            //benchmarks={this.props.benchmarks}
            //totalValue={totalValue}
        />
        <div className={'row'}>
          <div className='col-md-6'>
            <button
              onClick={this.saveClient}
              className={s.saveButton}
            >SAVE</button>
          </div>
          <div className='col-md-6'>
            <button
              onClick={this.clearEditMode}
              className={s.cancelButton}
            >CANCEL</button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  saveClient,
  setEditMode,
})(EditHoldingsForm);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/EditHoldingsForm.js